import { Layout, Variable } from "../../../../../ui/Icon/Icon";
import TileButton from "../../../../../ui/TileButton/TileButton";
import styles from "./SelectMethod.module.css";

interface SelectMethodProps {
  // onSelectKeywordList: () => void;
  onSelectNewKeywords: () => void;
  onSelectPattern: () => void;
}

function SelectMethod({
  // onSelectKeywordList,
  onSelectNewKeywords,
  onSelectPattern,
}: SelectMethodProps) {
  return (
    <div className={styles.buttons}>
      {/* <TileButton
        onClick={onSelectKeywordList}
        iconName="textInput"
        title="Choose from your Keyword list"
        subtitle="Select from keywords that we recommend"
      /> */}
      <TileButton
        IconComponent={Layout}
        onClick={onSelectNewKeywords}
        subtitle="Manually add your own new keywords"
        title="Add new Keywords"
      />
      <TileButton
        IconComponent={Variable}
        onClick={onSelectPattern}
        subtitle="Build a programmatic keyword pattern"
        title="Create a Pattern"
      />
    </div>
  );
}

export default SelectMethod;
